import { createSlice } from "@reduxjs/toolkit";

// Define the initial state using that type
const initialState: DetailState<IDataCenter> = {
  data: null,
  pageSize: 0,
  pageNumber: 0,
  totalCount: 0,
  showLoading: {
    sourceAction: "",
    state: false,
  },
  isLoading: false,
  isSuccess: false,
  details: null,
  view: null,
};

export const datacenterSlice = createSlice({
  name: "datacenter",
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {
    setLoading: (state, action) => {
      const { isLoading, isSuccess } = action.payload;
      state.showLoading = {
        sourceAction: action.payload.sourceAction,
        state: true,
      };
      state.isLoading = isLoading ? isLoading : false;
      state.isSuccess = isSuccess ? isSuccess : false;
    },
    resetLoading: (state, action) => {
      const { isLoading, isSuccess } = action.payload;
      state.showLoading = {
        sourceAction: "",
        state: false,
      };
      state.isLoading = isLoading ? isLoading : false;
      state.isSuccess = isSuccess ? isSuccess : false;
    },
    replaceDatacenter: (state, action) => {
      const { data, pageSize, pageNumber, totalCount } = action.payload;
      state.data = data;
      state.pageSize = pageSize;
      state.pageNumber = pageNumber;
      state.totalCount = totalCount;
    },
    addDatacenter: (state, action) => {
      const newItem: IDataCenter = action.payload.data;

      if (!state.data) {
        state.data = [newItem];
        state.totalCount = 1;
        return;
      }

      const updatedList = [newItem, ...state.data];

      updatedList.sort((a: IDataCenter, b: IDataCenter) => {
        const dateA = a.createdDate
          ? new Date(a.createdDate).getTime()
          : 0;

        const dateB = b.createdDate
          ? new Date(b.createdDate).getTime()
          : 0;

        return dateB - dateA;
      });

      if (updatedList.length > state.pageSize) {
        updatedList.pop();
      }

      state.data = updatedList;
      state.totalCount = state.totalCount + 1;
    },

    updateDatacenter: (state, action) => {
      const { data } = action.payload;

      if (state.data) {
        const index = state.data.findIndex(
          item => item.id === data.id
        );

        if (index !== -1) {
          state.data = state.data.map((item) =>
            item.id === data.id
              ? { ...item, ...data }
              : item
          );
        }
      }
      state.details = data;
    },

    deleteDatacenter: (state, action) => {
      const datacenterToRemove: IDataCenter = action.payload.data;
      const newDatacenterData =
        state.data &&
        state.data.filter((datacenter: IDataCenter) => {
          return datacenter.id !== datacenterToRemove.id;
        });
      state.data = newDatacenterData;
      state.totalCount = state.totalCount - 1;
    },
    setDatacenterDetails: (state, action) => {
      state.details = action.payload.data;
    },
    setView: (state, action) => {
      state.view = action.payload.view;
    },
  },
});

export const datacenterActions = datacenterSlice.actions;
export default datacenterSlice.reducer;
